// extracted by mini-css-extract-plugin
export default {"textArea":"text_area_textArea__Ggl6y"};